import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/lib/auth";
import { StudentAuthProvider } from "@/lib/studentAuth";
import SiteLayout from "@/components/site/SiteLayout";
import HomePage from "@/pages/Home";
import AboutPage from "@/pages/About";
import CoursesPage from "@/pages/Courses";
import ResultsPage from "@/pages/Results";
import TestimonialsPage from "@/pages/Testimonials";
import StudyMaterialsPage from "@/pages/StudyMaterials";
import BlogPage from "@/pages/Blog";
import FaqPage from "@/pages/Faq";
import ContactPage from "@/pages/Contact";
import AdminLogin from "@/pages/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminEnquiries from "@/pages/admin/AdminEnquiries";
import AdminStudents from "@/pages/admin/AdminStudents";
import AdminStudentDetail from "@/pages/admin/AdminStudentDetail";
import AdminCodes from "@/pages/admin/AdminCodes";
import StudentLogin from "@/pages/StudentLogin";
import StudentRegister from "@/pages/StudentRegister";
import StudentPortal from "@/pages/StudentPortal";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <StudentAuthProvider>
            <ScrollToTop />
            <Routes>
              <Route element={<SiteLayout />}>
                <Route path="/" element={<HomePage />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/courses" element={<CoursesPage />} />
                <Route path="/results" element={<ResultsPage />} />
                <Route path="/testimonials" element={<TestimonialsPage />} />
                <Route path="/study-materials" element={<StudyMaterialsPage />} />
                <Route path="/blog" element={<BlogPage />} />
                <Route path="/faq" element={<FaqPage />} />
                <Route path="/contact" element={<ContactPage />} />
              </Route>

              {/* Student portal */}
              <Route path="/student/login" element={<StudentLogin />} />
              <Route path="/student/register" element={<StudentRegister />} />
              <Route path="/student" element={<StudentPortal />} />

              {/* Admin */}
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<AdminEnquiries />} />
                <Route path="students" element={<AdminStudents />} />
                <Route path="students/:id" element={<AdminStudentDetail />} />
                <Route path="codes" element={<AdminCodes />} />
              </Route>
            </Routes>
            <Toaster position="top-right" richColors />
          </StudentAuthProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
